import { createBrowserRouter, Navigate } from 'react-router';
import { UsersPage, OrganizationsPage, ProductsPage } from '@lumlab/platform-admin/web';
import { RequireProduct } from './RequireProduct.tsx';
import { RequireAdministrator } from './RequireAdministrator.tsx';
import { HomePage } from '../pages/HomePage.tsx';
import { NotFoundPage } from '../pages/NotFoundPage.tsx';
import { SignInPage } from '../pages/SignInPage.tsx';
import { products } from '../products.ts';
import { AppLayout } from './AppLayout.tsx';
import { RequireSession } from './RequireSession.tsx';

export const router = createBrowserRouter([
    { path: '/sign-in', element: <SignInPage /> },
    {
        path: '/admin',
        element: (
            <RequireSession organizationRequired={false}>
                <RequireAdministrator>
                    <AppLayout administration />
                </RequireAdministrator>
            </RequireSession>
        ),
        children: [
            { index: true, element: <Navigate to="users" replace /> },
            { path: 'users', element: <UsersPage /> },
            { path: 'organizations', element: <OrganizationsPage /> },
            { path: 'products', element: <ProductsPage products={products} /> },
            ...products.flatMap((product) =>
                product.administration
                    ? [{ path: `products/${product.id}`, children: product.administration.routes }]
                    : [],
            ),
            { path: '*', element: <NotFoundPage /> },
        ],
    },
    {
        path: '/',
        element: (
            <RequireSession>
                <AppLayout />
            </RequireSession>
        ),
        children: [
            { index: true, element: <HomePage /> },
            ...products.map((product) => ({
                path: product.id,
                element: <RequireProduct productId={product.id} />,
                children: product.routes,
            })),
            { path: '*', element: <NotFoundPage /> },
        ],
    },
]);
